import { Component, OnInit, ViewChild, ElementRef } from '@angular/core';
import { gutil} from '../gutil';
import { HttpClient } from '@angular/common/http';
import { MapsAPILoader } from '@agm/core';
import { faMapMarker } from '@fortawesome/free-solid-svg-icons';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-golden-properties',
  templateUrl: './golden-properties.component.html',
  styleUrls: ['./golden-properties.component.scss']
})
export class GoldenPropertiesComponent implements OnInit {
  
  public faMapMarker = faMapMarker;
  public locationSel:any;
  public propertySel:any;
  public genderSel:any;
  public radiusSel: Array<any>;

  public addressActive: string;
  public genderActive: number;
  public propTypeActive: number;
  public citySel:any;
  public searchProperty = {address: "", sharetype: 4, gender: 3,radius:0, city: "bengaluru" , lat:0,long:0};
  public propertyData:any;
  public propertyDetail:any;
  public searchText="";

  public radiusSelActive:Array<any>;
  public proptypeText:any;
  public genderText: string;
  public addressText: string;
  public goldenProp = 0;
  public selectedRadius: number;
  public property_id:number;
  public goldenProperty = [];
  public loader : boolean;
  public selectedCity : string;
  public selectedGender: number;
  public selectedShareType : number;
  public stateName : string;

  @ViewChild("search")
  public searchElementRef: ElementRef;

  constructor(private http: HttpClient, private mapsAPILoader : MapsAPILoader,private router: Router, private routeact: ActivatedRoute) {

    this.radiusSel = gutil.radiusSel;
    this.selectedRadius = gutil.searchData.radius;
    this.locationSel = gutil.locationSel;
    this.radiusSel = gutil.radiusSel;
    this.propertySel = gutil.propTypeList;
    this.genderSel = gutil.genderSel;
    this.citySel = gutil.citySel;
   }

  ngOnInit(): void {
    window.scroll(0,0);
    this.routeact.params.subscribe((params) => {
      if(params.city == 'bengaluru') {
        this.searchProperty.city = "bengaluru";
        this.stateName = "Karnataka";
        this.addressActive = this.searchProperty.city.charAt(0).toUpperCase() + this.searchProperty.city.slice(1) + ', ' + "India";
        this.searchProperty.address = this.addressActive;
        this.filterSearch();
      }
      else {
        this.searchProperty.city = "pune";
        this.stateName = "Maharashtra";
        this.addressActive = this.searchProperty.city.charAt(0).toUpperCase() + this.searchProperty.city.slice(1) + ', ' + "India";
        this.searchProperty.address = this.addressActive;
        this.filterSearch();
      }
      var loc = params.locality;
      this.addressActive = loc;
    })
    // this.searchProperty.city = "bengaluru";
    
    this.genderActive = this.searchProperty.gender;
    this.propTypeActive = this.searchProperty.sharetype;
    this.selectedRadius = 0;
    this.searchProperty.gender = 0;
    this.filterSearch();

    this.mapsAPILoader.load().then(() => {
      let options : google.maps.places.AutocompleteOptions;
      options = {
        componentRestrictions: {country : 'in'},
      }
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement , options);
      autocomplete.addListener("places changed", () => {
        this.addressActive = autocomplete.getPlace().formatted_address;
        this.searchProperty.address = this.addressActive;
      })
    })
    this.loader = true;
  }

  public changeAddress(value:any) {
    this.searchProperty.address = value;
    this.filterSearch();
  }
  public changeCity(value:any) {
    this.searchProperty.city = value;
    this.addressActive = this.searchProperty.city.charAt(0).toUpperCase() + this.searchProperty.city.slice(1) + ', ' + "India";
    this.searchProperty.address = this.addressActive;
    this.getLocation();
    // this.filterSearch();
  }
  public changePropertyType(value:any) {
    this.searchProperty.sharetype = value;
    this.filterSearch();
  }
  public changeGender(value:any) {
    this.searchProperty.gender = value;
    this.filterSearch();
  }
  public changeRadius(value:any) {
    this.searchProperty.radius = value;
    this.filterSearch();
  }

  public filterSearch() {
    this.addressActive = this.searchProperty.address;
    this.loader = true;
    if(this.searchProperty.city == undefined || this.searchProperty.city == "") {
      this.searchText = "columns[city]=";
    }
    else {
      this.searchText = "columns[city]="+this.searchProperty.city;
    }
   
      if(this.searchProperty.gender !==undefined || this.searchProperty.gender > 0) {
        this.searchText = this.searchText + "&columns[gender]="+this.searchProperty.gender;
      }
      if(this.searchProperty.sharetype !==undefined || this.searchProperty.sharetype > 0) {
        this.searchText = this.searchText + "&columns[sharetype]="+this.searchProperty.sharetype;
      }
      if(this.searchProperty.radius !==undefined || this.searchProperty.radius > 0) {
        this.searchText = this.searchText + "&columns[radial_distance]="+this.searchProperty.radius;
      }
      
    this.http.get('https://api.yourownroom.com/api/w/v1/search/property?' + this.searchText)
    .subscribe((data:any) => {
      this.loader = false;
      this.propertyData = data;
      
      this.propertyDetail = this.propertyData.data;
      this.goldenProp = 0;
      let g = 0;
      
      this.goldenProperty = [];

      for(let gp=0; gp < this.propertyData.total; gp++) {
        if(this.propertyDetail[gp].property.golden == 1 && this.propertyDetail[gp].property.city == this.searchProperty.city) {
          if(this.propertyDetail[gp].property.status == "available" || this.propertyDetail[gp].property.status == "partial") {
            this.goldenProp +=1;
            this.goldenProperty[g] = this.propertyDetail[gp];
            g++;
          }
        }
      } 
    })
  }
////////////////////////////////// Google Auto Complete for search ///////////////////////////////////////////////
  public getLocation() {
    this.mapsAPILoader.load().then(() => {
      let options : google.maps.places.AutocompleteOptions;
      options = {
        componentRestrictions: {country : 'in'},
      }
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement , options);
      autocomplete.addListener("places changed", () => {
        this.addressActive = autocomplete.getPlace().formatted_address;
        this.searchProperty.address = this.addressActive;
        this.filterSearch();
        // this.findData();
      })
    })
  }
}
